import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {ConsultationCategoryModel} from '../../../api/model/consultationCategory.model';



@Injectable({providedIn: 'root'})
export class ConsultationCategoryRepository extends AbstractRepositoryV2<ConsultationCategoryModel>{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('ConsultationCategory', serviceElementsFactory, injector);
    }
}
